import axios from 'axios';

const { apiHost = '', relativeUrlRoot = '' } = window.chatwootConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}${relativeUrlRoot}/` });

export default wootAPI;
